import React from "react"
import { FaWindowClose } from "react-icons/fa";
import './ImportBox.css'

const ImportBox = ({onClose, handleFiles, fileInputRef, handleValidation}) => {



    const [importOptions, setImportOptions] = React.useState({
                    HDF5_File: 'HDF5 File',
                    Zip_File: 'Zip File',
                    Folder: 'Folder'
                })

    const [selectedImportType, setSelectedImportType] = React.useState('')



      const handleSelectChange = (index, event) => { };




    return(


      <div className="tmatrix-modal-backdrop-filter" onClick={onClose}>
      <div className="tmatrix-modal-content-filter" onClick={(e) => e.stopPropagation()}>
        <div className="filter-header-row">
          <h2 className="filter-title">Import Options</h2>
           <div className="icon-wrapper" data-tooltip="Close">
                        <FaWindowClose className="icon-clear" onClick={onClose} />
                      </div>
                    
        </div>

        <div className="filter-fields">
          <div className="list-select-filter">
            <label htmlFor="import-type">Select Import Type</label>
            <select
              id="import-type"
              value={selectedImportType}
              onChange={(e) => setSelectedImportType(e.target.value)}
              className="input-menu-filter"
            >
              <option value="" disabled>Select...</option>
              {Object.entries(importOptions).map(([key, label]) => (
                <option key={key} value={key}>{label}</option>
              ))}
            </select>
          </div>

          {selectedImportType === 'HDF5_File' && (
            <div className="nested-select-container">
              <label>Choose HDF5 File(s):</label>
              <input
                type="file"
                accept=".hdf5,.h5"
                multiple
                onChange={handleFiles}
                ref={fileInputRef}
                className="select-file"
              />
            </div>
          )}

          {selectedImportType === 'Zip_File' && (
            <div className="nested-select-container">
              <label>Choose a Zip File:</label>
              <input
                type="file"
                accept=".zip"
                onChange={handleFiles}
                ref={fileInputRef}
                className="select-file"
              />
            </div>
          )}

          {selectedImportType === 'Folder' && (
            <div className="nested-select-container">
              <label>Choose a Folder:</label>
              <input
                type="file"
                webkitdirectory="true"
                mozdirectory="true"
                directory=""
                onChange={handleFiles}
                ref={fileInputRef}
                className="select-file"
              />
            </div>
          )}
        </div>
         <button className="btn-upload-box" onClick={handleValidation}>
                  Upload
                </button>
      </div>
      
    </div>
    )




}


export default ImportBox